import { defineComponent as _defineComponent } from 'vue'
import type { PageListItem } from '@/components/nav/static-pages/types';
import { Domain, buildUrlForDomain } from '@/routing/helpers/subdomain-helper';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'PagesList',
  props: {
    pages: { default: () => [] },
    router: null,
    activeDomain: null
  },
  setup(__props: any) {

const { router, activeDomain } = __props as { pages: PageListItem[], router: ReturnType<typeof useRouter>, activeDomain?: Domain };



function getHref(page: PageListItem) {
	if (page.external) return page.fullPath;

	return `https://www.${JW_CONFIG.DOMAIN}${page.fullPath}`;
}

async function go(path: string, external: boolean) {
	const { popoverController } = await import('@/ionic.loader');

	if (!process.client) return;

	if (external) {
		window.open(path, '_blank', 'noopener');
	} else if (activeDomain !== Domain.MAIN) {
		// We're on a subdomain, need to redirect to main domain
		const targetUrl = buildUrlForDomain(path, Domain.MAIN);
		window.open(targetUrl, '_self', 'noopener');
	} else {
		router.push({ path });
	}

	popoverController.dismiss();
}

return { __sfc: true,router, activeDomain, getHref, go }
}

})